module.exports = __webpack_public_path__ + "img/browser1.c933918b.png";